import { COLOR_BASE_GREY_5 } from '@audi/audi-ui-design-tokens';
import { SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_300 } from '@oneaudi/unified-web-common';
import styled from 'styled-components';

export const StyledContentContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${SYS_SPACE_FIXED_300};
`;

export const StyledDialogSection = styled.section`
	display: flex;
	flex-direction: column;
	gap: ${SYS_SPACE_FIXED_200};
`;

export const StyledRemarksSection = styled.section`
	background-color: ${COLOR_BASE_GREY_5};
	padding: ${SYS_SPACE_FIXED_200};
`;
